import { Heading3, UIHeading1, UIHeading2 } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';
import { IQuickLinksTab, TQuickLinksVariant } from '../../containers/QuickLinksContainer/types';
import { useIsDesktop } from '../../hooks/common';
import { LinksList } from './LinksList';
import * as style from './style.css';
import { Tabs } from './Tabs';
import { getDefaultTab } from './utils/getDefaultTab';

interface IQuickLinksTabsComponentProps {
  tabs: IQuickLinksTab[];
  variant?: TQuickLinksVariant;
}

export const QuickLinksTabsComponent = ({ tabs, variant = 'default' }: IQuickLinksTabsComponentProps) => {
  const [selectedTab, setSelectedTab] = React.useState(getDefaultTab(tabs));
  const [isExpanded, setIsExpanded] = React.useState(false);
  const isDesktop = useIsDesktop();
  const isSidebar = variant === 'sidebar';

  const onTabChange = React.useCallback((_: React.ChangeEvent<HTMLInputElement>, value: number) => {
    setSelectedTab(value);
  }, []);
  const onMoreButtonClick = React.useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const links = React.useMemo(() => tabs[selectedTab].links, [tabs, selectedTab]);

  const title = isSidebar ? (
    <Heading3 fontWeight="700">Выберите фильтры</Heading3>
  ) : isDesktop ? (
    <UIHeading1>Выберите фильтры</UIHeading1>
  ) : (
    <UIHeading2>Выберите фильтры</UIHeading2>
  );

  return (
    <div
      className={clsx(
        style['container'],
        isSidebar && style['container-sidebar'],
        !isDesktop && !isSidebar && style['container-mobile'],
      )}
      data-testid="QuickLinks"
    >
      {title}
      {isExpanded && tabs.length > 1 && <Tabs tabs={tabs} value={selectedTab} onChange={onTabChange} />}
      <LinksList links={links} isExpanded={isExpanded} onMoreButtonClick={onMoreButtonClick} variant={variant} />
    </div>
  );
};
